export const ru = {
    from: 'Туда',
    to: 'Обратно',
    one_way: 'В одну сторону',
    round_trip: 'Туда–обратно',
};
